import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class CqScriptService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/cq-scripts', query);
  }

  create(body: any) {
    return this.post('/cq-scripts', body);
  }

  find(id) {
    return this.get('/cq-scripts/' + id);
  }

  update(id, body) {
    return this.put('/cq-scripts/' + id, body);
  }

  _delete(id) {
    return this.delete('/cq-scripts/' + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/CqScript.service.ts